import React from "react";
import PartsGallery from "./PartsGallery";
import { Visibility } from "semantic-ui-react";

const Showcase = props => (
  <div>
    <Visibility {...props} once={false}>
      <div
        className="section is-medium has-text-light"
        style={{ background: "rgb(54,54,54)" }}
      >
        <div className="container">
          <div className="columns">
            <div className="column is-5-desktop is-12-touch">
              <h1 className="title is-3 has-text-light">Showcase</h1>
              <p>
                Over the last half-century, Accratronics has manufactured
                millions of parts from thousands of different designs, each one
                as unique as the circumstances requiring it. We're proud to
                share a small sampling of some of our work that we believe
                exemplifies excellence in machining.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Visibility>
    <PartsGallery />
  </div>
);

export default Showcase;



// WEBPACK FOOTER //
// ./src/pages/Showcase/Showcase.js